module.exports = __webpack_public_path__ + "img/cloud-snow-sun-2.9538ca8d.svg";